import { createRouter, createWebHistory } from 'vue-router';

import Home from '../views/Home.vue';
import SubscriptionListByProduct from '../views/SubscriptionListByProduct.vue';
import CustomerTransactions from '../views/CustomerTransactions';
import AllCustomers from '@/views/AllCustomers.vue';
import CustomerSubcriptions from '@/views/CustomerSubscriptions.vue';
import { useAdminStore } from '@/store/admin';
const routes = [
  {
    path: '/',
    name: 'All Products',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:productId/subscriptions',
    name: 'Subscriptions',
    component: SubscriptionListByProduct,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/transactions/:customerId/:subscriptionId',
    name: 'Payment History',
    component: CustomerTransactions,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/all-customer-list',
    name: 'All Customer List',
    component: AllCustomers,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/all-customer-list/:customerId',
    name: 'Transaction History',
    component: CustomerTransactions,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/customer-subscriptions',
    name: 'Customer Subscriptions',
    component: CustomerSubcriptions,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  if (
    to.meta.requiresAuth &&
    // make sure the user is authenticated
    !useAdminStore().isAuthenticated &&
    // Avoid an infinite redirect
    to.name !== 'Login'
  ) {
    // redirect the user to the login page
    return { name: 'Login' };
  }
});

export default router;
